import Reports from "../components/Reports/Reports";

const ReportsPage = () => {
  return <Reports />;
};

export default ReportsPage;
